<template>
  <div class="mod-config">
    <el-form :inline="true" :model="dataForm" size="mini" ref="topForm">
      <el-form-item label="文件名称：">
        <el-input
          v-model="dataForm.name"
          placeholder="文件名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="文件哈希值：">
        <el-input
          v-model="dataForm.hash"
          placeholder="文件哈希值"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="区块哈希值：">
        <el-input
          v-model="dataForm.blockHash"
          placeholder="区块哈希值"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="存证时间：">
        <el-date-picker
          v-model="dataForm.fileUploadTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
          size="small"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          @click="getDataList(dataForm)"
          icon="el-icon-search"
          >查询</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="resetForm('topForm')">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="newDataList"
      border
      stripe
      v-loading="dataListLoading"
      style="width: 100%"
      :header-cell-style="{ background: '#f5f7fa' }"
    >
      <el-table-column align="center" prop="i" label="序号" width="80">
      </el-table-column>
      <el-table-column
        prop="unionId"
        header-align="center"
        align="center"
        label="上传人id"
      >
      </el-table-column>
      <el-table-column
        prop="fileName"
        header-align="center"
        align="center"
        label="文件名称"
      >
      </el-table-column>

      <el-table-column
        prop="fileSize"
        header-align="center"
        align="center"
        label="文件大小"
      >
        <template slot-scope="scope">
          <div>
            {{ getFileSize(scope.row.fileSize) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="fileOriginalHash"
        header-align="center"
        align="center"
        label="原始文件哈希"
      >
        <template slot-scope="scope">
          <div>
            <el-popover
              placement="bottom"
              width="250"
              trigger="click"
              :content="scope.row.fileOriginalHash"
            >
              <el-button slot="reference" type="text">查看</el-button>
            </el-popover>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="fileEncryptionHash"
        header-align="center"
        align="center"
        label="加密文件哈希">
      </el-table-column>
      <el-table-column
        prop="fileCertificateHash"
        header-align="center"
        align="center"
        label="证书文件哈希">
      </el-table-column>
      <el-table-column
        prop="fileCertificateAddress"
        header-align="center"
        align="center"
        label="证书文件地址">
      </el-table-column>
      
      <el-table-column
        prop="fileAddress"
        header-align="center"
        align="center"
        label="文件地址">
      </el-table-column>-->
      <el-table-column
        prop="blockHash"
        header-align="center"
        align="center"
        label="区块哈希"
      >
        <template slot-scope="scope">
          <div>
            <el-popover
              placement="bottom"
              width="250"
              trigger="click"
              :content="scope.row.blockHash"
            >
              <el-button slot="reference" type="text">查看</el-button>
            </el-popover>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="documentType"
        header-align="center"
        align="center"
        label="数据类型"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.documentType === 0">公证</span>
          <span v-if="scope.row.documentType === 1">电子签</span>
          <span v-if="scope.row.documentType === 2">存证宝</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="fileUploadTime"
        header-align="center"
        align="center"
        label="存证时间"
      >
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageNum"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
    >
    </el-pagination>
    <!-- 存证校验弹窗 -->
    <Verify ref="verify" />
  </div>
</template>

<script>
import Verify from "./dialog/depositVerify-dialog.vue";
export default {
  data() {
    return {
      dataForm: {
        name: "",
        hash: "",
        blockHash: "",
        fileUploadTime: null,
      },
      dataList: [],
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
    };
  },
  components: {
    Verify,
  },
  mounted() {
    this.getDataList();
  },
  computed: {
    newDataList() {
      let temData = [...this.dataList];
      temData.map((item, index) => {
        item.i = index + 1 + (this.pageNum - 1) * this.pageSize;
      });
      return temData
    },
  },
  methods: {
    // 获取数据列表
    getDataList(data) {
      this.dataListLoading = true;
      let temData = {};
      for (let key in data) {
        if (data[key] !== "" && data[key] !== null) {
          temData[key] = data[key];
        }
      }
      if ("fileUploadTime" in temData) {
        temData.startTime = temData.fileUploadTime[0];
        temData.endTime = temData.fileUploadTime[1];
        delete temData.fileUploadTime;
      }
      this.$api
        .getCunZhengList({
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          ...temData,
        })
        .then((res) => {
          if (res.data.code === "200" && res.data.data.code === 200) {
            this.totalPage = res.data.data.pageTotal
              ? parseInt(res.data.data.pageTotal)
              : 0;
            this.dataList = res.data.data.rows || [];
          }
        })
        .finally(() => {
          this.dataListLoading = false;
        });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.getDataList(this.dataForm);
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList(this.dataForm);
    },
    // 删除
    deleteHandle(id) {
      var ids = id
        ? [id]
        : this.dataListSelections.map((item) => {
            return item.id;
          });
      this.$confirm(
        `确定对[id=${ids.join(",")}]进行[${id ? "删除" : "批量删除"}]操作?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.$http({
          url: this.$http.adornUrl("/deposit/documencenter/delete"),
          method: "post",
          data: this.$http.adornData(ids, false),
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              onClose: () => {
                this.getDataList();
              },
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },
    //下载存证
    queryDeposit(row) {
      if (row.fileOriginalHash === "") {
        this.$message.error("hashcode为空");
        return;
      }
      const elink = document.createElement("a");
      elink.style.display = "none";
      elink.href = `/gzc/contract/downloadDeposit?hashCode=${row.fileOriginalHash}`;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    //校验弹窗显示
    showVerify(fileOriginalHash) {
      this.$refs.verify.open(fileOriginalHash);
    },
    //文件大小转换
    getFileSize(fileByte) {
      var fileSizeByte = fileByte;
      var fileSizeMsg = "";
      if (fileSizeByte < 1048576)
        fileSizeMsg = (fileSizeByte / 1024).toFixed(2) + "KB";
      else if (fileSizeByte == 1048576) fileSizeMsg = "1MB";
      else if (fileSizeByte > 1048576 && fileSizeByte < 1073741824)
        fileSizeMsg = (fileSizeByte / (1024 * 1024)).toFixed(2) + "MB";
      else if (fileSizeByte > 1048576 && fileSizeByte == 1073741824)
        fileSizeMsg = "1GB";
      else if (fileSizeByte > 1073741824 && fileSizeByte < 1099511627776)
        fileSizeMsg = (fileSizeByte / (1024 * 1024 * 1024)).toFixed(2) + "GB";
      else fileSizeMsg = "文件超过1TB";
      return fileSizeMsg;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dataForm.fileUploadTime = [];
      this.dataForm.name = '';
      this.dataForm.hash = '';
      console.log(this.dataForm);
      let temData = {};
      for (let key in this.dataForm) {
        if (this.dataForm[key] !== "" && this.dataForm[key] !== null) {
          temData[key] = this.dataForm[key];
        }
      }
      if ("fileUploadTime" in temData) {
        temData.beginDate = temData.fileUploadTime[0];
        temData.endDate = temData.fileUploadTime[1];
        delete temData.fileUploadTime;
      }
      this.getDataList();
    },
  },
};
</script>
